module.exports = __webpack_public_path__ + "img/006-plurk.4aaac9c6.svg";